'use strict';
module.exports = ([function () {
        return function (fileName) {
            var name = "";
            if (fileName) {
                var array = fileName.split('.');
                array.pop();
                angular.forEach(array, function (a) {
                    if (name !== "") {
                        name = name + ".";
                    }
                    name = name + a;
                });
            }
            return name;
        };
    }]);





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/fileNameFilter.js
// module id = 282
// module chunks = 0